export const testimonials = [
  {
    initials: 'VR',
    name: 'Valentina R.',
    location: 'Buenos Aires',
    role: 'Cliente verificada',
    text: 'Antes entrenaba glúteos y solo sentía las piernas. Con el Tomo 1 entendí que mi glúteo estaba dormido. En semana 3 ya mis jeans me quedaban diferente. Una locura.',
  },
  {
    initials: 'MS',
    name: 'Micaela S.',
    location: 'Córdoba',
    role: 'Cliente verificada',
    text: 'El Tomo 3 de la cintura me explotó la cabeza. Nadie me había explicado que los abdominales laterales ensanchan. Los dejé y en 2 semanas mi cintura se marcó sola.',
  },
  {
    initials: 'CF',
    name: 'Carolina F.',
    location: 'Rosario',
    role: 'Cliente verificada',
    text: 'El plan de 30 días del Tomo 4 es increíble. Todo organizado día por día. No pensás nada, solo abrís y hacés. Mis amigas me preguntan qué estoy haciendo.',
  },
]

export const moreTestimonials = [
  {
    initials: 'VR',
    name: 'Valentina R.',
    age: 32,
    location: 'Buenos Aires',
    role: 'Administrativa',
    text: 'Tengo 32 años y pasé 3 años entrenando sin entender por qué mi glúteo no crecía. El Tomo 1 me explicó la amnesia glútea y todo cambió. La conexión mente-músculo es totalmente real.',
  },
  {
    initials: 'MS',
    name: 'Micaela S.',
    age: 28,
    location: 'Córdoba',
    role: 'Docente',
    text: 'El Hip Thrust me lo explicaron por primera vez en el Tomo 2. Siempre lo había hecho mal y solo sentía la espalda. Ahora siento el glúteo arder en cada repetición. Noche y día.',
  },
  {
    initials: 'LM',
    name: 'Luciana M.',
    age: 25,
    location: 'Rosario',
    role: 'Estudiante',
    text: 'Dejé los abdominales laterales como dice el Tomo 3 y en 2 semanas se marcó mi cintura. Más glúteo, menos cintura. Es exactamente lo que todas queremos.',
  },
  {
    initials: 'AG',
    name: 'Agustina G.',
    age: 36,
    location: 'Mendoza',
    role: 'Mamá',
    text: 'El recetario del bono me salvó. Soy mamá y no tengo tiempo de pensar qué comer. Tener el menú armado con alimentos argentinos reales fue clave para no abandonar.',
  },
  {
    initials: 'DP',
    name: 'Daniela P.',
    age: 31,
    location: 'La Plata',
    role: 'Contadora',
    text: 'Al día 21 me saqué fotos comparativas y me quedé sin palabras. Mi silueta cambió completamente. Más glúteo, cintura marcada, postura totalmente diferente.',
  },
]

export const tomos = [
  {
    id: 'T1',
    name: 'Despertar Glúteo',
    months: 'Tomo 1 · Activación · Conexión · Técnica Base',
    content:
      'La base que toda mujer necesita. Activación glútea real, conexión mente-músculo y los 7 errores más comunes que frenan el crecimiento.',
    icon: '🔴',
  },
  {
    id: 'T2',
    name: 'Construcción de Masa',
    months: 'Tomo 2 · Hip Thrust · Sumo · RDL · Progresión',
    content:
      'Técnica avanzada de los ejercicios más efectivos rankeados por activación EMG. Progresión de 4 semanas con tracker incluido.',
    icon: '🟠',
  },
  {
    id: 'T3',
    name: 'Efecto Cintura',
    months: 'Tomo 3 · Cintura Visual · Postura · Proporción',
    content:
      'El secreto que multiplica el glúteo. Cómo crear cintura pequeña sin cirugía, sin faja y sin abdominales que ensanchan.',
    icon: '🟡',
  },
  {
    id: 'T4',
    name: 'Los 30 Días',
    months: 'Tomo 4 · Calendario · Nutrición · Tracker',
    content:
      'El plan completo día por día. Semanas 1 a 4 organizadas. Qué hacer, qué comer, cómo medir y qué sigue después.',
    icon: '🟢',
  },
]

export const bonuses = [
  {
    id: '01',
    icon: '🍱',
    name: 'Recetario 30 Días: Nutrición Glútea Argentina',
    desc: '30 días de comidas pensadas para Argentina. Recetas fáciles y económicas con alimentos accesibles, plan día a día, permitidos inteligentes de fin de semana, lista de lo que NO comer y el método 80/20 para no volverse loca con la dieta.',
    value: '$9.900',
  },
]

export const faqs = [
  {
    q: '¿Sirve si nunca entrené glúteos antes?',
    a: 'Sí, es perfectamente apto para principiantes. El Tomo 1 arranca desde cero con activación y conexión. No necesitás ninguna experiencia previa.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'Al completar el pago recibís un email con el link de descarga en menos de 5 minutos. Podés abrir los PDFs desde celular, tablet o computadora.',
  },
  {
    q: '¿Necesito ir al gimnasio?',
    a: 'No. Todo el programa está diseñado para hacerse en casa con elementos básicos: mancuernas livianas, una banda de resistencia y una silla resistente.',
  },
  {
    q: '¿Cuánto tiempo lleva cada sesión?',
    a: 'Las sesiones duran entre 40 y 70 minutos según la semana. El Tomo 4 incluye un Plan B de 20 minutos para días con poco tiempo.',
  },
  {
    q: '¿Hay mensualidad o suscripción?',
    a: 'No. Es un pago único. Pagás una vez y los PDFs son tuyos para siempre. Sin renovaciones ni cobros automáticos.',
  },
  {
    q: '¿La garantía es real?',
    a: '100% real. Si en 7 días sentís que no es lo que esperabas, escribís a compradigitalyaa@gmail.com y te devolvemos todo el dinero. Sin preguntas.',
  },
  {
    q: '¿Funciona si tengo mucho tiempo sin entrenar?',
    a: 'Sí. Las personas que vienen de inactividad tienen más margen de mejora en las primeras semanas. El Tomo 1 está especialmente diseñado para reactivar el glúteo tras períodos sedentarios.',
  },
  {
    q: '¿Puedo hacer este plan postparto o mientras amamanto?',
    a: 'Consultá siempre con tu médico primero. Muchos ejercicios de activación y core profundo son recomendados postparto, pero la decisión final es tuya junto con tu profesional de salud.',
  },
  {
    q: '¿Sirve si tengo sobrepeso o quiero bajar de peso también?',
    a: 'Sí. El método combina entrenamiento de glúteo con el recetario de nutrición argentina, lo que ayuda a recomponer la figura: más glúteo y menos cintura, sin dietas extremas.',
  },
  {
    q: '¿Voy a ver resultados reales en 30 días?',
    a: 'Sí. El Tomo 4 incluye un protocolo de medición y fotos comparativas para que veas el cambio el día 30. La mayoría nota diferencia visible a partir de la semana 3.',
  },
]

export const purchaseNotifications = [
  { name: 'Valentina R.', city: 'Buenos Aires', plan: '30 Días de Glúteos' },
  { name: 'Micaela S.', city: 'Córdoba', plan: 'Plan Total Glúteos' },
  { name: 'Luciana M.', city: 'Rosario', plan: '30 Días de Glúteos' },
  { name: 'Agustina G.', city: 'Mendoza', plan: 'Plan Total Glúteos' },
  { name: 'Daniela P.', city: 'La Plata', plan: '30 Días de Glúteos' },
  { name: 'Sofía T.', city: 'Mar del Plata', plan: 'Plan Total Glúteos' },
  { name: 'Camila B.', city: 'Salta', plan: '30 Días de Glúteos' },
  { name: 'Florencia V.', city: 'Tucumán', plan: 'Plan Total Glúteos' },
  { name: 'Brenda L.', city: 'Neuquén', plan: '30 Días de Glúteos' },
  { name: 'Romina C.', city: 'Bahía Blanca', plan: 'Plan Total Glúteos' },
]
